import React from 'react';
import {Checkbox} from 'semantic-ui-react';

import {
  InspectorPropertyLabel,
  InspectorPropertyWrapper,
} from '../Inspector.styles';
import {PropertyEditorComponent} from './property-editors';

/**
 * A simple checkbox editor for a boolean property.
 * Displays indeterminate state for mixed values.
 * Default is required.
 * @param props
 */
const CheckboxPropertyEditor: PropertyEditorComponent<'checkbox'> = props => {
  const displayedVal = props.values.length === 1 ? props.values[0] : undefined;
  return (
    <InspectorPropertyWrapper>
      <InspectorPropertyLabel>{props.displayName}</InspectorPropertyLabel>
      <Checkbox
        indeterminate={props.values.length > 1}
        checked={displayedVal}
        onChange={(e, {value, checked}) => {
          props.save(checked);
        }}></Checkbox>
    </InspectorPropertyWrapper>
  );
};

export default CheckboxPropertyEditor;
